import styled from '@emotion/styled'

const AddContact = ({ className, onClick }) => {
  return (
    <div
      className={className}
      onClick={onClick}
      onFocus={onClick}
      tabIndex="0"
    />
  )
}

export default styled(AddContact)`
  color: ${props => props.theme.color.monochrome.superDark};
  cursor: text;
  /* Prevent showing caret beside the add contact text */
  /* because users may think the field is focused and start typing, then trigger shortcuts */
  user-select: none;
  align-self: stretch;
  flex-grow: 1;
`
